import { IPermission } from "@miplatform/types";
import { getMissingDependentPermissions } from "./hasAnyDependentPermissions";

export const getPermissionDisableState = (
  permission: IPermission,
  assignedPermissions: string[]
) => {
  const missingDependencies = getMissingDependentPermissions(
    permission,
    assignedPermissions
  );
  const unauthorized = permission.currentUserHasPermission === false;
  const disabled = unauthorized || missingDependencies.length > 0;

  if (!disabled) {
    return {
      disabled: false,
      disabledReason: undefined,
    };
  }

  const disabledReasons: string[] = [];
  if (unauthorized) {
    disabledReasons.push(
      "You cannot assign this permission because your profile does not include it."
    );
  }

  if (missingDependencies.length > 0) {
    disabledReasons.push(`Requires one of: ${missingDependencies.join(", ")}`);
  }

  return {
    disabled: true,
    disabledReason: disabledReasons.join(" "),
  };
};
